import getApiClient from '@/shared/api/api-client/getApiClient';
import ApiResultStatus from '@/shared/api/api-result/ApiResultStatus';

export default async function getIfUserHasConversionsLogAccess(userId: string): Promise<
  | {
      errorMessage: string;
      status: ApiResultStatus.ERROR;
    }
  | {
      hasAccess: boolean;
      status: ApiResultStatus.OK;
    }
> {
  const client = getApiClient();

  const response = await client.get(`/api/conversions/log/access`, {
    params: {
      userId,
    } satisfies {
      userId: string;
    },
  });

  if (!response.ok) {
    return {
      errorMessage: await response.errorMessage(),
      status: ApiResultStatus.ERROR,
    };
  }

  const json = await response.json<{
    hasAccess: boolean;
  }>();

  return {
    hasAccess: json.hasAccess,
    status: ApiResultStatus.OK,
  };
}
